const origin = window.location.origin;

const localApi = "http://localhost:5000";
const liveApi = "https://spendboxbackend.com.ng";

export const API_URL = origin === "http://localhost:3000" ? localApi : liveApi;
export const PAYSTACK_PUBLIC_KEY =
  "pk_live_6c4c8ba024c109f0d0d7d4ea68c2b7918dd33eaf";
export const TEST_PAYSTACK_PUBLIC_KEY =
  "pk_test_a5162ce1d2a959647256d057c6d2c201808937b2";

export const LOGIN_BUSINESS_SUCCESSFUL = "LOGIN_BUSINESS_SUCCESSFUL";
export const LOGIN_BUSINESS_FAILED = "LOGIN_BUSINESS_FAILED";
export const LOGOUT_BUSINESS = "LOGOUT_BUSINESS";

export const REGISTER_BUSINESS_SUCCESSFUL = "REGISTER_BUSINESS_SUCCESSFUL";
